export default __webpack_public_path__ + "static/media/AlertLogMessage.bf4061e2.md";